(() => {
  if (window.__gsbCartTiers) return;
  window.__gsbCartTiers = true;

  /* ---------- <gsb-tier-bar> : re-renders from live cart data ---------- */
  class GsbTierBar extends HTMLElement {
    money(paise) { return this.dataset.symbol + Math.ceil(paise / 100).toLocaleString('en-IN'); }
    /* Parse "99900:5,149900:10," -> [{amt, pct}] */
    tiers() {
      return this.dataset.tiers.split(',').filter(Boolean).map((t) => { const [amt, pct] = t.split(':'); return { amt: +amt, pct }; });
    }
    render(sub) {
      const tiers = this.tiers(), seg = 100 / tiers.length;
      const prev = +this.dataset.state;
      const state = tiers.filter((t) => sub >= t.amt).length;
      let pct, msg;
      if (state === tiers.length) {
        pct = 100;
        msg = `Yay! You unlocked <strong>${tiers[state - 1].pct}% Off</strong>`;
      } else {
        const lo = state ? tiers[state - 1].amt : 0, next = tiers[state];
        pct = state * seg + ((sub - lo) * seg) / (next.amt - lo);
        msg = `Add <strong>${this.money(next.amt - sub)}</strong> more for <strong>${next.pct}% Off</strong>`;
      }
      this.dataset.state = state;
      this.dataset.sub = sub;
      this.querySelector('.gsb-tier__fill').style.width = pct + '%';
      this.querySelector('.gsb-tier__truck').style.left = pct + '%';
      const fd = this.querySelector('.gsb-tier__fd');
      if (fd) fd.classList.toggle('is-reached', sub >= +fd.dataset.amt);
      this.querySelector('.gsb-tier__msg').innerHTML = msg;
      this.querySelectorAll('[data-stop]').forEach((el) => el.classList.toggle('is-reached', state >= +el.dataset.stop));
      return state > prev;
    }
  }
  if (!customElements.get('gsb-tier-bar')) customElements.define('gsb-tier-bar', GsbTierBar);

  /* Ribbon burst from the bottom when a new offer tier is unlocked */
  const blast = () => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const colors = ['#ff006e', '#fb5607', '#ffbe0b', '#3a86ff', '#8338ec', '#06d6a0', '#ff4d6d', '#00bbf9'];
    const kinds = ['curl', 'curl', 'strip', 'dot', 'star'];
    const wrap = document.createElement('div');
    wrap.className = 'gsb-ribbons';
    for (let i = 0; i < 90; i++) {
      const c = colors[i % colors.length], c2 = colors[(i + 3) % colors.length];
      const kind = kinds[i % kinds.length];
      const r = document.createElement('i');
      r.className = 'gsb-ribbon--' + kind;
      if (kind === 'curl') {
        r.innerHTML = `<svg viewBox="0 0 12 64" aria-hidden="true"><path d="M6 2q6 7.5 0 15t0 15 0 15 0 15" stroke="${c}" stroke-width="3.5" stroke-linecap="round" fill="none"/></svg>`;
      } else {
        r.style.background = kind === 'strip' ? `linear-gradient(${c},${c2})` : c;
      }
      r.style.cssText += `left:${Math.random() * 100}%;` +
        `--h:${60 + Math.random() * 40}vh;--x:${(Math.random() - 0.5) * 35}vw;--r:${(Math.random() - 0.5) * 1080}deg;` +
        `animation-delay:${Math.random() * 0.35}s;animation-duration:${2 + Math.random() * 0.8}s`;
      wrap.appendChild(r);
    }
    document.body.appendChild(wrap);
    setTimeout(() => wrap.remove(), 3400);
  };

  let timer;
  const refresh = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      refreshTotals();
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          let unlocked = false;
          document.querySelectorAll('gsb-tier-bar').forEach((el) => { if (el.render(cart.items_subtotal_price)) unlocked = true; });
          if (unlocked) blast();
        })
        .catch(() => {});
    }, 150);
  };

  /* Update the bar after ANY cart change (drawer, product page, upsell) */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  const nativeFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    const p = nativeFetch.apply(this, args);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(refresh).catch(() => {});
    return p;
  };
  const xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (/\/cart\/(add|change|update|clear)/.test(url)) this.addEventListener('loadend', refresh);
    return xhrOpen.call(this, method, url, ...rest);
  };

  /* ---------- Re-render the cart UI from the same request (no 2nd fetch, no page reload) ----------
     The drawer is rendered on every page (also /cart), so both the drawer and the cart page
     sections are requested when they exist. */
  const cartSections = () => {
    const ids = ['cart-icon-bubble'];
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
    ['main-cart-items', 'main-cart-footer'].forEach((id) => {
      const el = document.getElementById(id);
      if (el && el.dataset.id) ids.push(el.dataset.id);
    });
    return { sections: ids, sections_url: window.location.pathname };
  };
  /* Footer "Est. Total" boxes only: safe to run after ANY cart change (doesn't touch the items being edited) */
  const refreshTotals = () => {
    const { sections } = cartSections();
    fetch(`${window.location.pathname}?sections=${sections.join(',')}`)
      .then((r) => r.json())
      .then((html) => {
        const fresh = Object.values(html).flatMap((h) => [...new DOMParser().parseFromString(h || '', 'text/html').querySelectorAll('.gsb-drawer-foot__total')]);
        document.querySelectorAll('.gsb-drawer-foot__total').forEach((el, i) => { if (fresh[i]) el.innerHTML = fresh[i].innerHTML; });
      })
      .catch(() => {});
  };
  const renderSections = (sections) => {
    if (!sections) return;
    const parse = (h) => new DOMParser().parseFromString(h, 'text/html');
    if (sections['cart-drawer']) {
      const doc = parse(sections['cart-drawer']);
      ['cart-drawer-items', '.cart-drawer__footer'].forEach((sel) => {
        const t = document.querySelector(sel), n = doc.querySelector(sel);
        if (t && n) t.replaceWith(n);
      });
    }
    ['main-cart-items', 'main-cart-footer'].forEach((id) => {
      const el = document.getElementById(id), html = el && sections[el.dataset.id];
      const target = html && el.querySelector('.js-contents'), source = html && parse(html).querySelector('.js-contents');
      if (target && source) target.innerHTML = source.innerHTML;
    });
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      const n = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (n) bubble.innerHTML = n.innerHTML;
    }
  };

  /* ---------- Featured coupon card (above Recommended For You) ---------- */
  const couponMsg = (box, text, ok) => {
    const m = box.querySelector('.gsb-coupons__msg');
    m.hidden = false;
    m.textContent = text;
    m.classList.toggle('is-ok', !!ok);
  };
  const applyCoupon = (btn) => {
    const box = btn.closest('.gsb-coupon-feature');
    const code = btn.dataset.code.trim();
    btn.disabled = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code, ...cartSections() }),
    })
      .then((r) => r.json())
      .then((cart) => {
        const d = (cart.discount_codes || []).find((x) => x.code.toLowerCase() === code.toLowerCase());
        if (!d || !d.applicable) throw new Error(`"${code}" is not valid for this cart`);
        couponMsg(box, `"${d.code}" applied!`, true);
        setTimeout(() => renderSections(cart.sections), 700);
      })
      .catch((err) => {
        btn.disabled = false;
        couponMsg(box, err.message || 'Could not apply this coupon. Please try again.');
      });
  };
  /* The storefront has no read-only discount check, so the code is tried on the cart and the cart's
     original codes are put back. nativeFetch keeps these trial requests from refreshing the bar. */
  const postDiscount = (discount) =>
    nativeFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount }),
    }).then((r) => r.json());
  const isValid = (cart, code) =>
    (cart.discount_codes || []).some((d) => d.applicable && d.code.toLowerCase() === code.toLowerCase());
  // Trial checks change the cart's codes for a moment, so run them one at a time
  let couponLock = Promise.resolve();
  const withCouponLock = (fn) => (couponLock = couponLock.then(fn, fn));

  /* Card stays hidden until Shopify confirms the code exists and fits this cart */
  class GsbCouponFeature extends HTMLElement {
    connectedCallback() {
      const code = this.dataset.code;
      withCouponLock(async () => {
        let ok = false, original = [];
        try {
          const cart = await nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
          original = (cart.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
          ok = original.some((c) => c.toLowerCase() === code.toLowerCase()) || isValid(await postDiscount(code), code);
        } catch (e) {}
        await postDiscount(original.join(',')).catch(() => {});
        this.hidden = !ok;
      });
    }
  }
  if (!customElements.get('gsb-coupon-feature')) customElements.define('gsb-coupon-feature', GsbCouponFeature);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.gsb-coupon-feature [data-gsb-coupon-apply]');
    if (btn && !btn.disabled) applyCoupon(btn);
  });

  /* ---------- Suggested products: desktop slider arrows (manual only) ---------- */
  const syncArrows = (list) => {
    const slider = list.closest('.gsb-upsell__slider');
    const prev = slider.querySelector('[data-dir="-1"]'), next = slider.querySelector('[data-dir="1"]');
    if (!prev) return;
    prev.disabled = list.scrollLeft <= 2;
    next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
  };
  document.addEventListener('click', (e) => {
    const arrow = e.target.closest('.gsb-upsell__arrow');
    if (!arrow) return;
    const list = arrow.closest('.gsb-upsell__slider').querySelector('.gsb-upsell__list');
    const item = list.querySelector('.gsb-upsell__item');
    list.scrollBy({ left: (item ? item.offsetWidth + 10 : list.clientWidth) * +arrow.dataset.dir });
  });
  document.addEventListener('scroll', (e) => {
    if (e.target.classList && e.target.classList.contains('gsb-upsell__list')) syncArrows(e.target);
  }, true);
  // Sync when the pointer reaches the slider (drawer may have been hidden, so width is unknown until then)
  document.addEventListener('pointerover', (e) => {
    const slider = e.target.closest && e.target.closest('.gsb-upsell__slider');
    if (slider) syncArrows(slider.querySelector('.gsb-upsell__list'));
  });

  /* Size pills: pick a variant -> update price + the "+" button's variant */
  document.addEventListener('click', (e) => {
    const pill = e.target.closest('.gsb-upsell__pill');
    if (!pill || pill.disabled) return;
    const card = pill.closest('.gsb-upsell__item');
    card.querySelectorAll('.gsb-upsell__pill').forEach((p) => {
      p.classList.toggle('is-active', p === pill);
      p.setAttribute('aria-pressed', p === pill);
    });
    card.querySelector('.gsb-upsell__add').dataset.variantId = pill.dataset.variantId;
    card.querySelector('.gsb-upsell__now').textContent = pill.dataset.price;
    const was = card.querySelector('.gsb-upsell__was');
    was.textContent = pill.dataset.compare;
    was.hidden = !pill.dataset.compare;
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.gsb-upsell__add');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    const id = Number(btn.dataset.variantId);
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }], ...cartSections() }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status) throw new Error(data.description || 'Could not add');
        btn.innerHTML = '✓';
        btn.classList.add('is-added');
        renderSections(data.sections);
      })
      .catch((err) => {
        btn.disabled = false;
        alert(err.message || 'Could not add this product. Please try again.');
      });
  });
})();